import Image from "next/image";

import { Photos } from "@/types/common/photos";

import SimpleSlider from "../../simpleSlider";

type Props = {
  media: Photos[] | undefined;
  mediaIndex: number | undefined;
  goToSlide: (index: number) => void;
  isZendesk?: boolean | undefined;
};

const BottomSlider = ({
  media,
  mediaIndex,
  isZendesk = false,
  goToSlide
}: Props) => {
  const handleClick = (index: number) => {
    goToSlide(index);
  };

  return (
    <SimpleSlider
      media={media}
      currentIndex={mediaIndex}
      isZendesk={isZendesk}
      afterChange={handleClick}
    >
      {media?.map((medium, index) => {
        return (
          <>
            <div
              className={`${
                index === mediaIndex ? "border-[2px]" : "border-none"
              } relative mr-8 inline-block h-[6.8rem] w-[10rem] border-[#00CECE] border-[] bg-gray-900`}
              key={medium.id}
              onClick={() => {
                handleClick(index);
              }}
            >
              <Image
                src={
                  isZendesk
                    ? medium.path
                    : `${process.env.APP_PHOTO_URL}/${medium.path}`
                }
                alt=""
                layout="fill"
                objectFit="cover"
              />
            </div>
          </>
        );
      })}
    </SimpleSlider>
  );
};

export default BottomSlider;
